import { phoneState } from '../state';
import ToastModule from '@modules/ToastModule';
import { connectionStatusStrings } from '../constants/connectionStatusStrings';

/**
 * Clears the recovery state and shows a success toast if recovery was in progress.
 * This function is called by both handleConnectionStatusUpdate (on RecoverySuccess)
 * and handlePhoneStateUpdate (when connectionStatus changes to Connected).
 */
export const clearRecoveryState = (): void => {
  if (!phoneState.isRecovering) {
    return;
  }

  phoneState.isRecovering = false;

  ToastModule.showToast({
    title: connectionStatusStrings.recoverySuccess,
    status: 'success',
  });
};
